import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Box } from '@mui/system'
import { Dialog, IconButton } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface ShopProductImageModalProps {
  onClose: () => void
  imageUrl: string
  place: number
}

const useStyles = makeStyles()(theme => ({
  dialogPaper: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    maxWidth: '100vw',
  },
  closeIcon: {
    position: 'absolute',
    top: theme.spacing(3),
    right: theme.spacing(3),
    color: theme.palette.common.black,
    zIndex: 1,
  },
  image: {
    height: '100%',
    width: 'auto',
    maxHeight: '80vh',
    maxWidth: '80vw',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100vw',
    },
  },
}))

/*
 * This component is called by as a Modal to show up image on bigger size
 */
const ShopProductImageModal: React.FC<ShopProductImageModalProps> = ({ imageUrl, onClose, place }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="lg"
      PaperProps={{
        className: classes.dialogPaper,
      }}
    >
      <IconButton className={classes.closeIcon} onClick={onClose}>
        <CloseIcon fontSize="large" />
      </IconButton>
      <Box component="img" src={imageUrl} alt={t('shop.product-modal.alt')} className={classes.image} />
    </Dialog>
  )
}

export default ShopProductImageModal
